<template>
    <UtilitiesWebView url="/city-tours?tour-type=Walking" />
</template>
